import React from 'react';
import { formatString } from '../../util/stringService';
import { EntityViewProps } from './EntityViewProps';
import { Typography } from '@material-ui/core';

export function EntityViewStringField(props: EntityViewProps) {
  const { value } = props;
  return <Typography>{formatString(value)}</Typography>;
}
